import { createIcon } from '@chakra-ui/react';

export const AddChildIcon = createIcon({
  displayName: 'AddChildIcon',
  viewBox: '0 0 16 14',
  path: (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.75 1C1.75 0.585786 1.41421 0.25 1 0.25C0.585786 0.25 0.25 0.585786 0.25 1V3V5V6V10C0.25 10.9665 1.0335 11.75 2 11.75H5C5.41421 11.75 5.75 11.4142 5.75 11C5.75 10.5858 5.41421 10.25 5 10.25H2C1.86193 10.25 1.75 10.1381 1.75 10V7.73228C1.83165 7.74396 1.91512 7.75 2 7.75H5C5.41421 7.75 5.75 7.41421 5.75 7C5.75 6.58579 5.41421 6.25 5 6.25H2C1.86193 6.25 1.75 6.13807 1.75 6V5V3.75L10 3.75C10.4142 3.75 10.75 3.41421 10.75 3C10.75 2.58579 10.4142 2.25 10 2.25L1.75 2.25V1ZM11.5 5C12.0523 5 12.5 5.44772 12.5 6V8.5H15C15.5523 8.5 16 8.94771 16 9.5C16 10.0523 15.5523 10.5 15 10.5H12.5V13C12.5 13.5523 12.0523 14 11.5 14C10.9477 14 10.5 13.5523 10.5 13V10.5H8C7.44772 10.5 7 10.0523 7 9.5C7 8.94771 7.44772 8.5 8 8.5H10.5V6C10.5 5.44772 10.9477 5 11.5 5Z"
        fill="currentColor"
      />
    </svg>
  ),
});
